class ImagesWithTextSwiper extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector('.swiper');
    if (!container || this.swiper || typeof Swiper === 'undefined') return;

    const slideCount = this.querySelectorAll('.swiper-slide').length;
    const autoplay = this.hasAttribute('data-autoplay');
    const interval = (parseInt(this.getAttribute('data-autoplay-interval'), 10) || 5) * 1000;

    this.swiper = new Swiper(container, {
      slidesPerView: 1,
      speed: 500,
      grabCursor: true,
      watchOverflow: true,
      loop: slideCount > 1,
      pagination: {
        el: this.querySelector('.images-with-text__dots'),
        type: 'bullets',
        clickable: true,
      },
      ...(autoplay && slideCount > 1
        ? { autoplay: { delay: interval, disableOnInteraction: false, pauseOnMouseEnter: true } }
        : {}),
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('images-with-text-swiper')) {
  customElements.define('images-with-text-swiper', ImagesWithTextSwiper);
}
